
export class LocaleSettings {

    public static setLocale(locale: string): void {
        locale = locale || 'en-AU';

        switch (locale) {
            case 'en-US':
                LocaleSettings._locale = 'en-US';
                LocaleSettings._currencyUnit = 'USD';
                break;
            case 'en-AU':
                LocaleSettings._locale = 'en-AU';
                LocaleSettings._currencyUnit = 'USD';
                break;
            case 'en-GB':
                LocaleSettings._locale = 'en-GB';
                LocaleSettings._currencyUnit = 'GBP';
                break;
        }
    }

    private static _currencyUnit: string = 'USD';
    private static _locale: string = 'en-AU';

    public static get currencyUnit(): string {
        return LocaleSettings._currencyUnit;
    };

    public static get currencySymbol(): string {
        // Probably should use the Intl way to do this but it seemed long winded
        return LocaleSettings._currencyUnit === 'USD' ? '$' : '£';
    }

    public static get locale(): string {
        return LocaleSettings._locale;
    }

    public static get isUK(): boolean {
        return LocaleSettings.locale === 'en-GB';
    }

    public static get defaultTimeZone(): string {
        switch (LocaleSettings.locale) {
            case 'en-GB':
                return 'Europe/London';

            default:
                return 'Australia/Sydney';
        }
    }

    public static get taxIdLabel(): string {
        return LocaleSettings.isUK
            ? 'VAT Reg No'
            : 'ABN';
    }

}